import * as _ from 'lodash';

const getErrorLabelForPath = (path, touched, errors) =>
  _.get(touched, path) && _.get(errors, path);
const pathHasError = (path, touched, errors) =>
  !!(_.get(touched, path) && _.get(errors, path));

const getErrorLabelForPathObject = (path, touched, errors, valueKey, t) =>
  _.get(touched, path) &&
  _.get(errors, `${path}.${valueKey}`) &&
  t(_.get(errors, `${path}.${valueKey}`));
const pathHasErrorObject = (path, touched, errors, valueKey) =>
  !!(_.get(touched, path) && _.get(errors, `${path}.${valueKey}`));

export {
  getErrorLabelForPath,
  pathHasError,
  getErrorLabelForPathObject,
  pathHasErrorObject
};
